import { BIBLE_REGISTRY } from "@bible/bibleRegistry";
import type { BibleBookId, EstimatedGameplayType } from "@bible/bibleRegistry.types";
import type { TranslationKey } from "@localization/types";

export type ChapterStatus = "available" | "comingSoon";

/**
 * Journey chapter view-model derived from the Bible Registry.
 * Do not hardcode chapter lists here — edit registry status / entries instead.
 */
export interface BibleChapter {
  id: string;
  order: number;
  book: BibleBookId;
  section: string;
  displayName: string;
  bibleReference: string;
  description: string;
  estimatedGameplayType: EstimatedGameplayType | EstimatedGameplayType[];
  parentChapterId: string | null;
  unlockRequirement: string | null;
  /** Localization key for playable chapters that already have i18n. */
  titleKey?: TranslationKey;
  /** Localization key for biblical reference when localized. */
  referenceKey?: TranslationKey;
  /** "available" chapters are playable; "comingSoon" appear locked on Journey. */
  status: ChapterStatus;
}

function toChapterStatus(status: string): ChapterStatus {
  return status === "available" ? "available" : "comingSoon";
}

/** Canonical journey list — sourced entirely from the Bible Registry. */
export const CHAPTERS: BibleChapter[] = BIBLE_REGISTRY.map((entry) => ({
  id: entry.id,
  order: entry.chronologicalOrder,
  book: entry.book,
  section: entry.section,
  displayName: entry.displayName,
  bibleReference: entry.bibleReference,
  description: entry.description,
  estimatedGameplayType: entry.estimatedGameplayType,
  parentChapterId: entry.parentChapterId,
  unlockRequirement: entry.unlockRequirement,
  titleKey: entry.titleKey as TranslationKey | undefined,
  referenceKey: entry.referenceKey as TranslationKey | undefined,
  status: toChapterStatus(entry.status),
}));
